import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaPaintBrush, FaPalette, FaTools, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Restauração de Móvel
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/restauracaomovel.css'; // CSS específico para esta página

const RestauracaoMovel = () => {
  // Array com as imagens da galeria
const galleryImages = [
  { 
    id: 1, 
    src: '/img/movel/1.jpg', 
    alt: 'Cada móvel é restaurado com precisão artesanal, devolvendo sua beleza e funcionalidade originais.' 
  },
  { 
    id: 2, 
    src: '/img/movel/2.jpg', 
    alt: 'Processo minucioso de restauração para preservar a história e o valor de cada peça.' 
  },
  { 
    id: 3, 
    src: '/img/movel/3.jpg', 
    alt: 'Transformamos móveis desgastados em verdadeiras obras de arte.' 
  },
  { 
    id: 4, 
    src: '/img/movel/4.jpg', 
    alt: 'Técnicas tradicionais e materiais de alta qualidade garantem resultados duradouros.' 
  },
  { 
    id: 5, 
    src: '/img/movel/5.jpg', 
    alt: 'O cuidado com cada detalhe revela a essência de móveis que atravessam gerações.' 
  },
  { 
    id: 6, 
    src: '/img/movel/6.jpg', 
    alt: 'Reavivamos a elegância e o estilo de móveis clássicos e contemporâneos.' 
  },
  { 
    id: 7, 
    src: '/img/movel/7.jpg', 
    alt: 'A restauração de móveis une tradição e inovação, criando peças únicas.' 
  },
  { 
    id: 8, 
    src: '/img/movel/8.jpg', 
    alt: 'Valorizamos a história e a memória de cada móvel restaurado com carinho e profissionalismo.' 
  },
];

const restauracaoMovelSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Restauração de Móvel de Piano",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Serviço completo de restauração estética do móvel do piano, incluindo remoção de pintura antiga, recuperação da madeira, laqueação ou tingimento, e acabamento em alto brilho ou acetinado.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/restauracao-movel"
};




  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];

  return (

    <div className="restauracao-movel-container">
      <SeoHead
  title="Restauração de Móvel de Piano | Waldir Pianos"
  description="Devolva a beleza original ao seu piano com nossa restauração completa do móvel. Pintura, verniz, laqueação, clareamento e polimento para um acabamento impecável."
  keywords="restauração móvel piano, pintura piano, verniz piano, laqueação piano, clareamento madeira piano, Waldir Pianos"
  image="/img/restauracao-movel/1.jpg" 
  url="https://pianoswaldir.com.br/restauracao-movel"
  canonicalUrl="https://pianoswaldir.com.br/restauracao-movel"
  schemaMarkup={restauracaoMovelSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="restauracao-movel-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="restauracao-movel-header-content">
          <motion.h1
            className="restauracao-movel-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaPaintBrush className="restauracao-movel-title-icon" />
            Restauração de Móvel
            <span className="restauracao-movel-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="restauracao-movel-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Transformando seu piano em uma obra de arte
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="restauracao-movel-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="restauracao-movel-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="restauracao-movel-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="restauracao-movel-section-title">
              <FaPalette className="restauracao-movel-section-icon" />
              Renovação Estética Completa
            </h2>

            <p className="restauracao-movel-classic-text">
              "Especialidade da casa. Executamos verdadeiras obras de arte no aspecto visual do móvel do piano."
            </p>

            <div className="restauracao-movel-modern-text">
              <p>Nossos serviços incluem:</p>
              <ul>
                <li>Remoção total da pintura/verniz antigo.</li>
                <li>Recuperação de pequenas partes danificadas da madeira e folhamentos.</li>
                <li>6 a 8 demãos de bases e fundos.</li>
                <li>Aplicação de verniz novo ou laqueação na cor de preferência ou clareamento ou tingimento da madeira natural.</li>
                <li>Acabamento alto brilho ou acetinado.</li>
                <li>Polimento e lustração do móvel e das partes metálicas (pedais, dobradiças, fechadura).</li>
                <li>Troca ou pintura da cobertura dos teclados.</li>
              </ul>
            </div>

            <div className="restauracao-movel-benefits-grid">
              <div className="restauracao-movel-benefit-item">
                <FaPaintBrush className="restauracao-movel-benefit-icon" />
                <span>Acabamentos de alto padrão</span>
              </div>
              <div className="restauracao-movel-benefit-item">
                <FaTools className="restauracao-movel-benefit-icon" />
                <span>Restauração completa da superfície</span>
              </div>
              <div className="restauracao-movel-benefit-item">
                <FaCheckCircle className="restauracao-movel-benefit-icon" />
                <span>Personalização de cor e brilho</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

<motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Restauração do Móvel</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="restauracao-movel-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="restauracao-movel-footer-text">Seu piano merece um novo brilho?</p>
        <motion.a
          href="tel:1122565987"
          className="restauracao-movel-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default RestauracaoMovel;